import { notEmpty } from '../functions';
export function formatTimestamp(timestamp) {
    return new Intl.DateTimeFormat('hu-HU').format(timestamp);
}
export function formatDate(date) {
    return new Intl.DateTimeFormat().format(date);
}
export function formatHighResTimestamp(millis) {
    const rs = Math.floor(millis / 1000);
    const ms = Math.floor(millis - (rs * 1000));
    return [
        formatSeconds(rs),
        pad(ms, 3)
    ].join('.');
}
export function formatSeconds(seconds) {
    const rs = Math.floor(seconds);
    const h = Math.floor(rs / 3600);
    const m = Math.floor((rs - (h * 3600)) / 60);
    const s = Math.floor(rs - (h * 3600) - (m * 60));
    return [
        h > 0 ? pad(h, 2) : null,
        pad(m, 2),
        pad(s, 2)
    ].filter(notEmpty).join(':');
}
//
function pad(n, width) {
    return String(n).padStart(width, '0');
}
//# sourceMappingURL=time.js.map